<template>
    <div>
        <general-header v-bind:content="{header: 'Terms of Service', subheader: '', buttonText: 'Get Started', buttonIcon: '', buttonPosition: '', to: ''}"></general-header>

        <section class="tos">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <p>If you use Best Meta in any way, whether it be as an account holder or a casual browser, you are agreeing to these Terms Of Service and our Privacy Policy in a contractual way.</p>

                        <p>Best Meta reserves the right to disable or delete entirely any content or account that violates this Terms Of Service, compromises the security of our servers, or is considered undesirable by us. These definitions are defined at our sole discretion.</p>

                        <p>If you upload some content, you represent and warrant to us that in doing so you are not violating anyone else's rights and that you created the content you are uploading or have legal right to complete the upload. Do not upload copyrighted content that you do not have the right to upload.</p>

                        <p>Best Meta does not expressly or implicitly endorse anything you submit to Best Meta, and cannot be held liable for anything you or any other user submits to Best Meta.</p>

                        <p>Best Meta will not be held liable for any damages you may incur by using Best Meta for any reason under the sun. You use Best Meta at your own risk, and if you do not agree with our terms of service and our Privacy Policy, then do not use Best Meta.</p>

                        <p>Best Meta is for entertaining yourself and Best Meta cannot be held responsible for anything you do based on what you found at Best Meta. that includes claims, loses, damages and other liabilities.</p>

                        <p>Best Meta is not directed at people under the age of 13. Best Meta does not knowingly collect any personal information from such people. If you know that a user under the age of 13 is accessing Best Meta, please contact us <a href="innermonkdesign@gmail.com">here</a>.</p>

                        <p>Best Meta will respond to legitimate DMCA requests if you feel your copyright has been compromised.</p>

                        <p>You may not post content that we consider spam.</p>

                        <p>You may not hurt other users or impede on other Best Meta users ability to operate Best Meta.</p>

                        <p>Best Meta cannot be held liable in a monetary or lawful sense for anything that is found on Best Meta. Each users assumes responsibility at the time of upload, and Best Meta cannot guarantee the terms of service agreements once you leave Best Meta.</p>

                        <p>Best Meta is not an API and cannot be used as such. Best Meta must be used only on https://www.bestmeta.com by using the search fields on the site. If you use Best Meta by data-scraping or as an API, your usage of Best Meta may be denied.</p>

                        <p>Best Meta reserves the right to change these terms and our Privacy Policy at any time, without notice, and for any reason.</p>
                    </div>
                </div>
            </div>
        </section>

        <general-header
            v-bind:content="{
                header: 'Looking for the best products?',
                subheader: '',
                buttonText: 'Search',
                buttonIcon: 'search',
                iconPosition: 'left',
                to: 'home'
            }">
        </general-header>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'tos',
    computed: {
        ...mapGetters({
            user: 'user/user'
        })
    },
    mounted () {
    }
}
</script>

<style lang="scss" scoped>

    .tos {
        padding: 45px 0;
    }

</style>
